import type { CmsApiFlashCardQuizBlockData } from '#/modules/cms/api/types/blocks/CmsApiFlashCardQuizBlock';
import type { CmsBlockMapping } from '#/modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from '#/modules/cms/mappers/CmsMappedBlockWidth';
import { dynamic } from '#/utils/dynamic';

export const CmsFlashCardQuizBlockMapping: CmsBlockMapping<CmsApiFlashCardQuizBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: dynamic(
      () =>
        import('./CmsFlashCardQuizBlock').then((m) => ({
          default: m.CmsFlashCardQuizBlock,
        })),
      { strategy: 'always' },
    ),
  };
